export const normalizeNodeNumber = (value: number): number => {
  const num = Number(value);

  // In GraphQL, the Int type is a 32-bit signed integer.
  // The valid value range is from -2147483648 to 2147483647.
  //
  // Values outside this range (for example, large numbers
  // or numbers represented in scientific notation like 2.07e10)
  // cannot be parsed correctly by GraphQL and will result in
  // a parse-failed error.
  // Therefore, values must be explicitly validated to ensure
  // they are integers and fall within this range before
  // sending them to the API.
  if (!Number.isInteger(num)) {
    throw new Error(`nodeNumber is not integer: ${value}.`);
  }

  if (num < -9223372036854775808 || num > 9223372036854775808) {
    throw new Error(
      'Node number must be less than or equal to 9,223,372,036,854,775,808.'
    );
  }

  return num;
};
